
import { Heart, Users, Award, Calendar, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

// Family photos - emphasized
const familyPhotos = [
  {
    id: 1,
    name: "Michelle Jessen",
    role: "Owner & Daughter",
    imagePath: "/colorado-plumbing-uploads/michellemelodee.png",
    description: "Michelle, Owner - family is at the heart of everything we do"
  },
  {
    id: 2, 
    name: "Codee Jessen",
    role: "Owner & Master Plumber with Son",
    imagePath: "/colorado-plumbing-uploads/codeechristian.png",
    description: "Codee, licensed Master Plumber and owner"
  }
];

// Project photos - smaller gallery style
const projectImages = [
  {
    id: 3,
    title: "Company Vehicle",
    imagePath: "/colorado-plumbing-uploads/brand/codee-christian-plumbing-truck.png"
  },
  {
    id: 4,
    title: "Service Truck", 
    imagePath: "/colorado-plumbing-uploads/brand/emergency-plumbing-vehicle-colorado-first-plumbing-and-sewer.png"
  },
  {
    id: 5,
    title: "Excavation Work",
    imagePath: "/colorado-plumbing-uploads/existing-projects/sawcut-street-denver-plumber-sewer.png"
  },
  {
    id: 6,
    title: "Water Heater Installation",
    imagePath: "/colorado-plumbing-uploads/existing-projects/trustworthy-plumbers-water-heater-littleton.png"
  },
  {
    id: 7,
    title: "Pipe Installation",
    imagePath: "/colorado-plumbing-uploads/existing-projects/sewer-dig-double-cleanout.png"
  },
  {
    id: 8,
    title: "Tankless Water Heater",
    imagePath: "/colorado-plumbing-uploads/existing-projects/prefab-tankless-water-heater-piping.png"
  },
  {
    id: 9,
    title: "Professional Installation",
    imagePath: "/colorado-plumbing-uploads/existing-projects/tankless-water-heater-professional-install-highlands-ranch.png"
  },
  {
    id: 10,
    title: "Basement Plumbing",
    imagePath: "/colorado-plumbing-uploads/existing-projects/sewer-repair-experts.png"
  },
  {
    id: 11,
    title: "Pipe Repair",
    imagePath: "/colorado-plumbing-uploads/existing-projects/gas-pipe-install-lakewood-colorado-first-plumbing.png"
  },
  {
    id: 12,
    title: "Rinnai Installation",
    imagePath: "/colorado-plumbing-uploads/existing-projects/rinnai-tankless-water-heater-expert-installer-colorado-first-plumbing.png"
  },
  {
    id: 13,
    title: "Excavation Project",
    imagePath: "/colorado-plumbing-uploads/existing-projects/Rheem-tankless-install-colorado-first-plumbing-and-sewer.png"
  },
  {
    id: 14,
    title: "Service Vehicle",
    imagePath: "/colorado-plumbing-uploads/existing-projects/plumbing-truck-residential-best-plumber-castle-rock.png"
  }
];

const Gallery = () => {
  return (
    <section id="family" className="py-24 bg-gradient-to-br from-blue-800 to-blue-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#FFFFFF_1px,transparent_1px)] [background-size:32px_32px]"></div>
      
      <div className="container-custom relative z-10">
        {/* Header Section */}
        <div className="text-center max-w-3xl mx-auto mb-16 reveal-slide" style={{ '--reveal-delay': 0 } as React.CSSProperties}>
          <div className="inline-block px-4 py-2 mb-6 rounded-full bg-blue-100 text-blue-800 font-semibold text-sm border border-blue-200">
            👨‍👩‍👧‍👦 Family Owned & Operated
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            <span className="text-gradient bg-gradient-to-r from-blue-200 to-green-400 bg-clip-text text-transparent">Family Owned</span> and Operated Since 2018
          </h2>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 text-left max-w-4xl mx-auto">
            <h3 className="text-xl font-bold text-white mb-3">👨‍👩‍👧‍👦 Who owns and operates Colorado First Plumbing and Sewer LLC?</h3>
            <p className="text-lg text-blue-100 leading-relaxed">
              Colorado First Plumbing and Sewer LLC is proudly owned by <Link to="/codee-jessen" className="text-blue-400 underline hover:text-blue-300">Codee Jessen</Link>, a Colorado Licensed Master Plumber who has extensive experience in sewer repair, tankless water heater installs, and Multifamily Residential. He has completed over 20,000 documented hours in the Plumbing industry. His Wife, <Link to="/michelle-jessen" className="text-blue-400 underline hover:text-blue-300">Michelle Jessen</Link> is the Majority Owner, making this company a Woman-owned small Business. She manages the CRM and backend operation, and brings years of management and operational expertise to this Colorado family owned plumbing business.
            </p>
          </div>
        </div>

        {/* Family Photos - Emphasized */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16 reveal-slide" style={{ '--reveal-delay': 1 } as React.CSSProperties}>
          {familyPhotos.map((person, index) => (
            <div key={person.id} className="group">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2 hover:shadow-2xl">
                <div className="text-center">
                  <div className="relative mb-6 mx-auto w-64 h-64 rounded-full overflow-hidden ring-4 ring-white/30 group-hover:ring-white/50 transition-all duration-300">
                    <img 
                      src={person.imagePath}
                      alt={person.name}
                      className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">{person.name}</h3>
                  <p className="text-blue-200 font-semibold mb-3">{person.role}</p>
                  <p className="text-blue-100 italic">{person.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Family Values Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 reveal-slide" style={{ '--reveal-delay': 2 } as React.CSSProperties}>
          <div className="text-center group">
            <div className="w-16 h-16 bg-gradient-to-r from-green-600 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300">
              <Heart size={32} className="text-white" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Family Values</h3>
            <p className="text-blue-100">Treating every customer like family with honest, transparent service and fair pricing. Codee and Michelle run this business with strong family values.</p>
          </div>
          
          <div className="text-center group">
            <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300">
              <Users size={32} className="text-white" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Local Community</h3>
            <p className="text-blue-100">Codee and Michelle are proud Denver Metro residents. We live here, work here, and are raising our family in this community we serve.</p>
          </div>
          
          <div className="text-center group">
            <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300">
              <Award size={32} className="text-white" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Professional Excellence</h3>
            <p className="text-blue-100">Master Plumber owned with 4.8★ rating from 293+ customers. Quality work backed by our family name.</p>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mb-16 reveal-slide" style={{ '--reveal-delay': 3 } as React.CSSProperties}>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-4">Experience the Family Difference</h3>
            <p className="text-blue-100 mb-6">
              When you choose Colorado First Plumbing, you're choosing Codee and Michelle's family-owned expertise, transparent pricing, and service that comes from the heart. We treat your family like our own.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a 
                href="/pricing"
                className="relative bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 hover:from-yellow-300 hover:via-orange-400 hover:to-red-400 text-white px-8 py-4 rounded-full text-xl font-black inline-flex items-center transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:scale-[1.08] ring-4 ring-yellow-300/50 hover:ring-yellow-200/70 animate-gradient-shift"
                style={{
                  textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                  boxShadow: '0 0 30px rgba(251, 191, 36, 0.6), 0 0 60px rgba(251, 191, 36, 0.4), 0 20px 40px rgba(0,0,0,0.3)',
                  backgroundSize: '300% 300%',
                  animation: 'gradient-shift 3s ease-in-out infinite'
                }}
              >
                <span className="relative z-10 flex items-center">
                  💰 See Actual Pricing Now
                  <ExternalLink size={20} className="ml-3" />
                </span>
              </a>
              
            </div>
          </div>
        </div>

        {/* Project Photos - Smaller Gallery */}
        <div className="reveal-slide" style={{ '--reveal-delay': 4 } as React.CSSProperties}>
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-white mb-2">Our Professional Work</h3>
            <p className="text-blue-200">A glimpse of the quality projects we complete for Denver Metro families</p>
          </div>
          
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 max-w-5xl mx-auto">
            {projectImages.map((image) => (
              <div 
                key={image.id} 
                className="group aspect-square rounded-lg overflow-hidden border-2 border-white/20 hover:border-white/40 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
              >
                <img 
                  src={image.imagePath}
                  alt={image.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 opacity-90 group-hover:opacity-100"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
